export enum ExternalProviderType {
  Lusha = 'Lusha',
  Cognism = 'Cognism',
  ZoomInfo = 'ZoomInfo',
  Apollo = 'Apollo',
}

export enum ExternalProviderError {
  InvalidApiKey = 'InvalidApiKey',
  InvalidAccessToken = 'InvalidAccessToken',
}

export interface PostExternalEnrichmentProviderPayload {
  externalProviderType: ExternalProviderType;
  apiKey?: string;
  enrichEmail: boolean;
  enrichPhone: boolean;
  enrichLinkedin: boolean;
  enrichCompany: boolean;
  beforeCronoProviders: boolean;
  authType: EnrichmentAuthType;
  clientId?: string;
  clientSecret?: string;
}

export interface PatchExternalEnrichmentProviderPayload {
  id: number;
  apiKey?: string;
  enrichEmail?: boolean;
  enrichPhone?: boolean;
  enrichLinkedin?: boolean;
  enrichCompany?: boolean;
  enabled?: boolean;
  beforeCronoProviders?: boolean;
  clientId?: string;
  clientSecret?: string;
}

export interface ExternalEnrichmentProvider {
  id: number;
  externalProviderType: ExternalProviderType;
  secretEnding?: string;
  clientSecretEnding?: string;
  externalProviderError?: ExternalProviderError;
  enrichEmail?: boolean;
  enrichPhone?: boolean;
  enrichLinkedin?: boolean;
  enrichCompany?: boolean;
  enabled: boolean;
  beforeCronoProviders: boolean;
  displayOrder: number;
  authType: EnrichmentAuthType;
  clientId?: string;
  clientSecret?: string;
  isConnected?: boolean;
}

export enum EnrichmentAuthType {
  ApiKey = 'ApiKey',
  App = 'App',
}
